function x(n) {
  var i, o, a, l, f, g, s, d, t, u, r, k;
  return {
    defaultTextWidth: 120,
    fontFamily: ((a = (o = (i = n == null ? void 0 : n.tokens) == null ? void 0 : i.heading) == null ? void 0 : o["01"]) == null ? void 0 : a.fontFamily) ?? '"IBM Plex Sans", "Helvetica Neue", Arial, sans-serif',
    fontSize: ((g = (f = (l = n == null ? void 0 : n.tokens) == null ? void 0 : l.heading) == null ? void 0 : f["01"]) == null ? void 0 : g.fontSize) ?? 14,
    fontWeight: ((t = (d = (s = n == null ? void 0 : n.tokens) == null ? void 0 : s.heading) == null ? void 0 : d["01"]) == null ? void 0 : t.fontWeight) ?? 400,
    lineCount: 1,
    lineHeight: ((k = (r = (u = n == null ? void 0 : n.tokens) == null ? void 0 : u.heading) == null ? void 0 : r["01"]) == null ? void 0 : k.lineHeight) ?? 20
  };
}
export {
  x as getTextCalculationConfig
};
